import { useContext, useEffect } from 'react';
import { AuthContext } from 'modules/shared/context/AuthContext';

export const Retently = () => {
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.retently.com/public/components/embed/sdk.min.js';
    script.id = 'retently-jssdk';
    script.type = 'text/javascript';

    script.onload = () => {
      console.log('Retently script loaded successfully');
    };

    script.onerror = () => {
      console.error('Error loading Retently script');
    };

    document.body.appendChild(script);

    return () => {
      const scriptElement = document.getElementById('retently-jssdk');
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, []);

  return user ? (
    <div
      id="retently-survey-embed"
      data-campaignid="67accbb24413268a23b2448e"
      data-href="https://app.retently.com/api/remote/tracking/5e7e2ee492910a433a3a35b7"
      data-rel="dialog"
      data-campaign="regular"
      data-email={user.email}
      data-firstname={user.first_name}
      data-lastname={user.last_name}
      data-tags={process.env.RETENTLY_ENV_TAG}
      data-prop-user_scopes={user.scopes}
    />
  ) : null;
};

export default Retently;
